<template>
    <div class="container-fluid">

        <CRow class="pr-2">
    <CCol col="12" xl="10" class="p-0">
      <CCard class="pt-2">
        <CCardBody>
          <a-card class="edit-card" style="margin:0; margin-top:10px" :body-style="{padding:0}">
                          <span slot="title">
                            <h6 class="w-100 mb-0 text-muted">Role používateľov</h6>
                            Všetky role
                          </span>
                          <span slot="extra">
                                    <router-link to="/role/add" class="d-none d-md-inline">
                                            <a-button type="primary" >Nová rola</a-button>
                                    </router-link>
                                  </span>
                        <div class="d-md-none mobile-toolbar" style="padding: 8px 16px; justify-content: flex-end; border-bottom: 1px solid #e8e8e8;">
                          <router-link to="/role/add"><a-button type="primary" size="small">Nová rola</a-button></router-link>
                          <a-dropdown class="ml-1">
                            <a-button size="small"><i class="fas fa-ellipsis-v"></i></a-button>
                            <a-menu slot="overlay">
                              <a-menu-item><router-link to="/users">Zoznam používateľov</router-link></a-menu-item>
                              <a-menu-item><router-link to="/permissions">Právomoci</router-link></a-menu-item>
                            </a-menu>
                          </a-dropdown>
                        </div>

                        <div class="table-responsive">
                            <a-table
                                    :columns="columns"
                                    :rowKey="record => record.id"
                                    :dataSource="data"
                                    :loading="loading"
                                    :scroll="{ x: 600 }"
                                    class="table-flush">
                                <template slot="name" slot-scope="user">
                                    <span class="actions">
                                        <router-link :to="'/role/' + user.id">
                                            <a-button class="mr-1">Upraviť</a-button>
                                        </router-link>
                                        <a-popconfirm placement="topRight"
                                                      @confirm="confirm(user.id)"
                                                      @cancel="cancel"
                                                      okText="Áno"
                                                      cancelText="Nie">
                                            <template slot="title">
                                                <h5 color="danger" >Prajete si tento obsah vymazať?</h5>
                                                Položka bude trvalo odstránená z vašej stránky.
                                            </template>
                                            <a-button type="danger">Zmazať</a-button>
                                        </a-popconfirm>
                                    </span>
                                </template>
                            </a-table>
                        </div>
          </a-card>
          </CCardBody>
          </CCard>
          </CCol>

   <CCol col="12" xl="2" class="pl-0 d-none d-xl-block">
<CCard class="pl-0 pt-0">
  <CCardBody>
    <a-card class="edit-card" style="margin:0; padding:15px;" :loading="saving">
     <div class="option-buttons">

            <router-link :to="'/users'"><a-button type="secondary" class="mr-2">Zoznam používateľov</a-button></router-link>
            <router-link :to="'/permissions'"><a-button type="secondary" class="mr-2">Právomoci</a-button></router-link>
                            </div>

      </a-card>

  </CCardBody>
</CCard>
  </CCol>
          </CRow>
          </div>
</template>
<script>
    import {dataService} from "../_services";
    import {Popconfirm} from "ant-design-vue"

    const columns = [
        {
            title: '',
            width: '10px',
        },
        {
            title: 'Name',
            dataIndex: 'title',
            sorter: true,
            width: '20%',
        },
        {
            title: 'slug',
            dataIndex: 'slug',
        },
        {
            align: 'right',
            scopedSlots: {customRender: 'name'},
        },
          {
            title: '',
            width: '10px',
        },
    ];

    export default {
        name: "roles",
        components: {
            "a-popconfirm": Popconfirm
        },
        data() {
            return {
                data: [],
                colorsto: JSON.parse(localStorage.colors),
                loading: false,
                saving: false,
                columns,
            };
        },
        mounted() {
            this.fetch();
        },
        methods: {
            confirm(e) {
                dataService.axiosDelete(this.$options.name, e).then(results => {
                    if (results) {
                        this.data.splice(this.data.findIndex(x => parseInt(x.id) === parseInt(e)), 1);
                    }
                });
            },
            cancel() {
            },
            fetch() {
                this.loading = true;
                dataService.axiosFetch(this.$options.name).then(results => {
                    this.data = results;
                    this.loading = false;
                });
            }

        },
    };
</script>

<style>
    ul.ant-pagination {
        margin-top: 0;
        margin-bottom: 1em;
    }

    .ant-table-pagination.ant-pagination {
        margin-bottom: 40px;
        margin-right: 20px;
    }

    .ant-pagination5-item {
        border: 0;
    }

    .ant-table {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        margin-bottom: 20px;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a, .ant-pagination5-jump-prev a, .ant-pagination5-jump-next a {
        -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        border: 0;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 0;
        margin: 0 3px;
        border-radius: 50% !important;
        width: 36px;
        height: 36px;
        font-size: 0.875rem;
    }


    .ant-pagination5-item.ant-pagination5-item-active a {
        z-index: 1;
        color: #fff;
        background-color: #5e72e4;
        border-color: #5e72e4;
    }

    .ant-pagination5-item-link.ant-pagination5-disabled a {
        color: #8898aa;
        pointer-events: none;
        cursor: auto;
        background-color: #fff;
        border-color: #dee2e6;
    }

</style>
